/*
	import { addRecurringEvent } from '@/services/CalendarEvent/CommunityCalendarRecurringEvent/Post';

  const { result, successful, message } = await addRecurringEvent ({
    json: {}
  });
  if (!successful) {
    console.error (message);
    return;
  }
*/

import kms from '@/services/kms'

export async function addRecurringEvent({ json }) {
  let message = 'The event could not be added.'

  try {
    const result = await kms.post(`/CalendarEvent/CommunityCalendarRecurringEvent`, json)

    return {
      successful: true,
      message,
      result
    }
  } catch (exception) {
    console.error(exception)
  }

  return {
    successful: false,
    message,
    result: {}
  }
}
